import { render, staticRenderFns } from "./NoMoreMatchesCard.vue?vue&type=template&id=26329237&"
import script from "./NoMoreMatchesCard.vue?vue&type=script&lang=js&"
export * from "./NoMoreMatchesCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports